import CryptoJS from "crypto-js";
import html2pdf from "html2pdf.js";
import XLSX from "xlsx";

export function formatDate(date, showTime = false) {
	return date
		? `${new Date(new Date(date).toISOString())}`
				.split(" ")
				.splice(0, showTime ? 5 : 4)
				.join(" ")
		: null;
}

export const formatAmount = (amount, noDecimal) =>
	Number(parseFloat(amount || 0).toFixed(2)).toLocaleString(undefined, {
		minimumFractionDigits: noDecimal ? 0 : 2
	});

export const formatPositiveAmount = (amount) =>
	amount > 0 ? formatAmount(amount) : 0;

export const percentIncrease = (prev, curr) => {
	if (prev < 1) return 0;

	return formatAmount(((+curr - +prev) / +prev) * 100);
};

export const exportExcel = (data, headers, fileName) => {
	if (!(data || []).length) return;

	const ws = XLSX.utils.json_to_sheet(data);
	ws["!cols"] = autoFitColFromHeader(headers);
	const wb = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws);
	return XLSX.writeFile(wb, fileName);
};

export const autoFitColFromHeader = (headers = []) => {
	return headers.map((header) => ({ wch: header[0].length + 2 }));
};

export const remapObj = (obj = [], headers = []) => {
	return obj.map((data) => {
		return headers.reduce((acc, header) => {
			acc[header[0]] =
				typeof header[2] === "function"
					? header[2](data[header[1]])
					: data[header[1]] || "N/A";
			return acc;
		}, {});
	});
};

export const getStatusText = (flag) => {
	if (flag.includes("0")) return "Pending";
	if (flag.includes("1")) return "Cancelled";
	if (flag.includes("2")) return "Rejected";
	if (flag.includes("3")) return "Approved";
	if (flag.includes("4")) return "Revoked";
	if (flag.includes("5")) return "Pending Approval";
	if (flag.includes("6")) return "Deleted";
};

export const printHTML = (html) => {
	const blob = new Blob([html], { type: "text/html" });
	const blobUrl = URL.createObjectURL(blob);

	const w = window.open(blobUrl, "_blank");
	w.onload = () => {
		w.focus();
		w.print();
	};

	w.onafterprint = () => {
		w.close();
	};
};

export const downloadHTMLDocInPDF = (html, fileName) => {
	html2pdf().set({ filename: fileName }).from(html).toPdf().save();
};

export const downloadFetchedPDF = (pdfFile, fileName) => {
	/**
	 * This is for downloading PDF files that have been fetched from the server.
	 * This function expects a raw binary format of pdf file
	 *
	 * Please remember to add `responseType: 'blob'` to your axios request
	 * config when downloading PDF from server,
	 * otherwise this function won't work as expected
	 *  */
	const blob = new Blob([pdfFile], { type: "application/pdf" });
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		window.navigator.msSaveOrOpenBlob(blob, fileName);
	} else {
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.download = fileName;
		document.body.appendChild(link);
		link.click();

		// Clean up DOM
		document.body.removeChild(link);
		window.URL.revokeObjectURL(url);
	}
};
export const returnPhoneNumberPattern = () => "^(?:0d{10}|+[1-9]d{1,14})$";

export const encrypt = (toEncrypt) => {
	const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPTION_KEY);
	const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPTION_IV);
	let encrypted;
	encrypted = CryptoJS.AES.encrypt(
		CryptoJS.enc.Utf8.parse(JSON.stringify(toEncrypt)),
		key,
		{
			keySize: 128 / 8,
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		}
	);
	return encrypted.toString();
};
